export default __webpack_public_path__ + "static/media/fcbd15ee71ff1f42bb6d3c7f7ee79b4c1581601393937.6bc33cf6.webp";